import { connect } from 'react-redux';
import React, { Component } from 'react';
import {Link, browserHistory} from 'react-router';
import imm from 'immutable';

import {http_methods} from '../utils';
import {
  TreeNavMenuItem,
  TreeNavMenu,
  TreeNavNodes
} from 'react-fe-bootstrap';
import MethodBadge from './MethodBadge';
import {ListItem} from 'material-ui';
import {ContentAddBox as ExpandTree, ContentRemoveCircle as CollapseTree} from 'material-ui/svg-icons';

const buttonStyle = {
  float: 'right'
};

const innerDivStyle = {paddingLeft: '40px', paddingBottom: '0px', paddingTop: '0px', lineHeight: '40px'};

class RouteTree extends Component {
  constructor(props) {
    super(props);

    const api = props.selected.get('api');
    const route = props.selected.get('route');
    const method = props.selected.get('method');
    const joined = `/${api}/${route}`;

    this.state = {
      hovering: false,
      collapsed: !joined.startsWith(this.props.path)
    };
  }

  shouldComponentUpdate(newProps, newState) {
    return newState.collapsed !== this.state.collapsed ||
      newProps.spec !== this.props.spec ||
      newProps.text !== this.props.text ||
      newProps.active === 'editor' && this.props.selected !== newProps.selected; // selection change in editor
  }

  componentWillReceiveProps(props) {
    if (props.active === 'editor') { // selection change in editor
      const api = props.selected.get('api');
      const route = props.selected.get('route');
      const method = props.selected.get('method');
      const joined = `/${api}/${route}`;

      this.setState({
        collapsed: !joined.startsWith(this.props.path)
      });
    }
  }

  onMouseOver(event) {
    const self = this;

    clearTimeout(this.state.ctx);
    this.props.onEndHover();

    const data = {
      x: event.clientX + 5,
      y: event.clientY - 5,
      message: this.props.path
    };

    const show_tooltip = setTimeout(() => {
      self.props.onHover(data);
    }, 500);

    self.setState({
      hovering: true,
      ctx: show_tooltip
    });
  }

  onMouseMove(event) {
    const self = this;

    clearTimeout(this.state.ctx);
    this.props.onEndHover();

    const data = {
      x: event.clientX + 5,
      y: event.clientY - 5,
      message: this.props.path
    };

    const show_tooltip = setTimeout(() => {
      self.props.onHover(data);
    }, 500);

    self.setState({
      hovering: true,
      ctx: show_tooltip
    });
  }

  onMouseLeave(event) {
    clearTimeout(this.state.ctx);
    this.props.onEndHover();
  }

  onToggle(event) {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  onSelect(event, ctx) {
    const url = ctx.method ? `${ctx.path}#${ctx.method}` : ctx.path;
    browserHistory.push(url);
    this.props.onClick({url});
    event.stopPropagation();
  }


  render() {
    const self = this;
    const {spec, path, text, depth = 0, ...others} = this.props;

    if (!spec) {
      return null;
    }

    const label_text = text || path;
    const [onMouseOver, onMouseMove, onMouseLeave, onToggle, onSelect] = ['onMouseOver', 'onMouseMove', 'onMouseLeave', 'onToggle', 'onSelect'].map(name => self[name].bind(self));

    if (!spec.keySeq) {
      return null;
    }

    const children = spec.keySeq().toJS().filter(key => /^\//.test(key)).map(key => {
      const new_path = path + key;
      return <RouteTree key={new_path} text={key} spec={spec.get(key)} path={new_path} depth={depth + 1} {...others}/>;
    });

    let operations = [];
    try {
      operations = spec.get('methods', imm.fromJS({})).keySeq().toJS().filter(op => http_methods[op]).reverse();
    }
    catch(err) {
      // TODO: handle any immutable.js errors
    }

    if(children.length === 0) {
      return <TreeNavMenuItem {...this.props}>
              <Link role="link" className="nav-tree__link" to={path}>{label_text}</Link>
              <span className="nav-tree__badges">
                {operations.map(op => <MethodBadge key={op} method={op} style={buttonStyle} onClick={event => onSelect(event, {path, method: op})}/>)}
              </span>
          </TreeNavMenuItem>
    } else {
      return <TreeNavMenu {...this.props} role="menuItem">
          <TreeNavMenuItem role="root">
              <Link role="link" to={path}>{label_text}</Link>
              <span className="nav-tree__badges">
                {operations.map(op => <MethodBadge key={op} method={op} style={buttonStyle} onClick={event => onSelect(event, {path, method: op})}/>)}
              </span>
          </TreeNavMenuItem>
          <TreeNavNodes role="menu">
             {children}
          </TreeNavNodes>
      </TreeNavMenu>;
    }

    // return <ListItem
    //   style={this.props.style}
    //   innerDivStyle={innerDivStyle}
    //   nestedListStyle={this.props.style}
    //   nestedLevel={depth}
    //   initiallyOpen={false}
    //   leftIcon={children.length === 0 ? null :
    //     this.state.collapsed ?
    //       <ExpandTree style={{top: '-5px', left: '-2px'}} onTouchTap={onToggle}/> :
    //       <CollapseTree style={{top: '-5px', left: '-2px'}} onTouchTap={onToggle}/>
    //   }
    //   primaryText={label}
    //   onContextMenu={event => onContextMenu(event, {path})}
    //   onMouseOver={onMouseOver}
    //   onMouseMove={onMouseMove}
    //   onMouseLeave={onMouseLeave}
    //   onClick={event => onSelect(event, {path})}
    //   primaryTogglesNestedList={false}
    //   autoGenerateNestedIndicator={false}
    //   nestedItems={children}
    //   ref={e => {
    //     if (e) {
    //       e.setState({
    //         open: !this.state.collapsed
    //       });
    //     }
    //   }}
    // />;
  }
}

export default connect(
  state => (
    {
      selected: state.get('apis').get('selected'),
      active: state.get('tabs').get('active')
    }
  ),
  dispatch => (
    {
      onClick(data) {

      },
      onHover(data) {
        dispatch({type: 'SHOW_TOOLTIP', data});
      },
      onEndHover() {
        dispatch({type: 'HIDE_TOOLTIP'});
      }
    }
  )
)(RouteTree);
